import { CommercialPageShell } from "@/components/commercial/commercial-page-shell";
import { CommercialSocialValue } from "@/components/commercial/commercial-social-value";

const PATH = "/commercial-social-value";
const PAGE_TITLE = "Social Value";

export function LpCommercialSocialValue() {
 return (
 <CommercialPageShell
 pageTitle={PAGE_TITLE}
 pagePath={PATH}
 sourcePage={PATH}
 serviceOfInterest="Social Value Enquiry"
 submitLabel="Discuss Social Value Reporting"
 intro={
 <>
 <p className="text-xs font-bold uppercase tracking-widest text-accent mb-2">Social Value</p>
 <h1 className="text-2xl md:text-4xl font-bold text-foreground leading-tight mb-4">
 {PAGE_TITLE}
 </h1>
 <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
 Social value is agreed up front against your framework&apos;s measures, local jobs, apprenticeships,
 supply chain and community benefit, and reported on completion with evidence your panel can use.
 We tailor reporting to your format, not a generic PDF.
 </p>
 </>
 }
 >
 <CommercialSocialValue />
 </CommercialPageShell>
 );
}

export { PATH as COMMERCIAL_SOCIAL_VALUE_PATH, PAGE_TITLE as COMMERCIAL_SOCIAL_VALUE_TITLE };
